// Module federation is not currently used (manifest is empty)
// If needed in the future, update to use @module-federation/enhanced/runtime
// as @nx/angular/mf is deprecated in Nx 22
import('./bootstrap').catch((err) => console.error(err));

